// extracted by mini-css-extract-plugin
export default {"root":"nabqWuWR","outlet":"_48jLaKCl"};